<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h4>Descuentos</h4>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <th>Zona</th>
              <th>Cultivo</th>
              <th>Cantidad HA</th>
              <th>Valor HA</th>
              <th>Descuento</th>
            </thead>
            <tbody>
              <tr v-for="risk in risks" :key="risk.id">
                <td>
                  {{ risk.zone?.description }}
                </td>
                <td>
                  {{ risk.crop?.description }}
                </td>
                <td>{{ risk.numberOfHectares }} HA</td>
                <td>{{ risk.hectarePrice }} {{ risk.hectarePriceCurrencyId | unidadValorHA }}</td>
                <td>
                  <fg-input
                    cy-id="discount"
                    type="number"
                    class="discount-input"
                    min="0"
                    max="100"
                    addonRightIcon="fa fa-percent"
                    v-model="risk.discount"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    risks: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formdata: {
        risks: []
      }
    };
  },
  computed: {
    isDataLoaded() {
      let idl = true;
      if (this.formdata.risks.length > 0) {
        this.formdata.risks.forEach(risk => {
          if (risk.zone === undefined || risk.crop === undefined) {
            idl = false;
          }
        });
      } else {
        idl = false;
      }
      return idl;
    }
  }
};
</script>

<style lang="scss" scoped>
.discount-input {
  width: 125px;
  margin: 0px;

  .input-group-append i.fa {
    width: 40px;
  }
}
.table td {
  white-space: nowrap;
}
</style>
